// Icons of the cloud projects, as path data in the canvas's 16 × 16 style (see `ICONS` in `ui.ts`).

/** A folder: the header's Projects entry and a project without a thumbnail. */
export const FOLDER_ICON = "M2.5 4.5h4l1 1.2h6v6.8h-11z";

/** Two sheets: duplicate. */
export const DUPLICATE_ICON = "M5.5 5.5h7v7h-7z|M3.5 10.5v-7h7";

/** A cloud: the connection's status. */
export const CLOUD_ICON = "M4.5 12.5a2.7 2.7 0 0 1-.4-5.3 3.8 3.8 0 0 1 7.2-.6 3 3 0 0 1 .2 5.9z";
